import React, { useState } from "react";
import FilterShell from "./FilterShell";

const defaultState = { name: "", licensePlate: "", type: "" };

const UserVehiclesFilters = ({ onApply, initial = null }) => {
  const [data, setData] = useState({ ...defaultState, ...(initial || {}) });

  const onChange = (e) =>
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));

  return (
    <FilterShell
      onApply={() => onApply(data)}
      onClear={() => {
        setData(defaultState);
        onApply(defaultState);
      }}
    >
      <div className="col-md-4">
        <label className="form-label">Vehicle Name</label>
        <input
          type="text"
          name="name"
          className="form-control"
          value={data.name}
          onChange={onChange}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label">License Plate</label>
        <input
          type="text"
          name="licensePlate"
          className="form-control"
          value={data.licensePlate}
          onChange={onChange}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label">Type</label>
        <select
          name="type"
          className="form-control"
          value={data.type}
          onChange={onChange}
        >
          <option value="">All types</option>
          <option value="compact">Compact</option>
          <option value="standard">Standard</option>
          <option value="suv">SUV</option>
        </select>
      </div>
    </FilterShell>
  );
};

export default UserVehiclesFilters;
